module.exports = __webpack_public_path__ + "static/media/Spraying.593c9183.svg";